export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑面料',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'ME',
    disabled: ({ fabricStatus, approvalStatus }) => !['Q'].includes(fabricStatus) || ['P'].includes(approvalStatus) || !that.addFabric,
  },
  {
    text: that.$l('menu_text_copy') || '复制面料',
    icon: 'el-icon-document-copy',
    menuType: 'copy',
    allow: 'MC',
    disabled: () => !that.addFabric,

  },
  {
    text: that.$l('menu_text_delete') || '删除面料',
    icon: 'el-icon-delete',
    menuType: 'del',
    divided: true,
    allow: 'MD',
    disabled: ({ fabricStatus, approvalStatus }) => !['Q'].includes(fabricStatus) || ['P'].includes(approvalStatus) || !that.addFabric,
  },
  {
    text: that.$l('menu_text_submit') || '提交审核',
    icon: 'el-icon-circle-check',
    menuType: 'submit',
    divided: true,
    allow: 'MS',
    disabled: ({ fabricStatus, approvalStatus }) => !['Q'].includes(fabricStatus) || ['P'].includes(approvalStatus) || !that.addFabric,
  },
]
